export default __webpack_public_path__ + "static/media/3101.1a1eb4f3.jpg";